import React from 'react';
import ReactDOM from 'react-dom';

import '../../scss/main.scss';
import CookiePolicy from '~/commons/components/CookiePolicy.jsx';

const root = document.getElementById('cookie-policy');

if (root) {
  ReactDOM.render(
    <CookiePolicy />,
    root,
  );
}
